import { useEffect } from 'react';
import { useTheme } from 'styled-components';

import errorDisc from '../assets/svg/disc/error-disc.svg';
import type { ContentfulTagProps } from '../types/propTypes';

const GeneralError = ({
  contentfulTag,
  contentType,
  error,
}: Pick<ContentfulTagProps, 'contentfulTag' | 'contentType' | 'error'>) => {
  const theme = useTheme();

  useEffect(() => {
    if (error) {
      console.error(error);
    }
    if (contentfulTag) {
      console.warn(contentfulTag, contentType);
    }
  }, [error, contentfulTag, contentType]);

  return (
    <div>
      <div className="text-center mb-3">
        <img src={errorDisc} alt="Error disc" />
      </div>
      <h1 className="mb-3">This service is temporarily unavailable</h1>
      <p>
        Sorry, {theme.language.brandName}’s services are temporarily down and we aren’t able to complete your smart
        meter registration at this time. We’re looking into the reasons for this. Typically our services are back up
        quickly. Please come back and try again later.
      </p>
    </div>
  );
};

export default GeneralError;
